<template>
  <div class="padding-five-lr" style="background: #f8f8f8">
    <div class="padding-ten-tb no-printme">
      <b-row style="max-width: 100%">
        <b-col xs="6" sm="6" md="6" lg="6">
          <h5 class="color-gray">Detalle Proyecto </h5>
      
        </b-col>
        <b-col xs="6" sm="6" md="6" lg="6" class="text-right">
          <b-breadcrumb :items="items"></b-breadcrumb>
        </b-col>
      </b-row>
    </div>
    <div class="padding-five-all bg-white no-printme">
      <b-row>
        <b-col cols="12">
          <h5 class="text-orange">Datos generales</h5>
        </b-col>
      </b-row>
      <b-row>
        <b-col xs="12" sm="12" md="12" lg="3">
          <label for="input-small" class="text-grey">
            N° Orden de Servicio V.T
            </label>
          <span>
            {{ detailOS.sequence }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3">
          <label for="input-small" class="text-grey">Tienda</label>

          <span>
            {{ detailOS.store }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3">
          <label for="input-small" class="text-grey">Fecha creación Proyecto:</label>

          <span>
            {{ project.fechaRegistro?formatDate(project.fechaRegistro):"" }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3">
          <label for="input-small" class="text-grey">Estado de la OS:</label>

          <span>
            {{ detailOS.status }}
          </span>
        </b-col>
      </b-row>
    </div>
    <div class="padding-five-all bg-white no-printme">
      <h5 class="text-orange">Datos del cliente</h5>
      <b-row>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey">Nombre completo</label>

          <span>
            {{ detailOS.name }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey">Doc. Identidad</label>

          <span>
            {{ detailOS.identityDocument }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey">Correo electrónico</label>

          <span>
            {{ detailOS.mail }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey">Teléfono Principal</label>

          <span>
            {{ detailOS.phone }}
          </span>
        </b-col>
      </b-row>
      <b-row>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey">Teléfono Secundario</label>

          <span>
            {{ detailOS.phoneSecondary }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey">Departamento</label>

          <span>
            {{ detailOS.department }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey">Provincia</label>
          <span>
            {{ detailOS.province }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey">Distrito</label>

          <span>
            {{ detailOS.district }}
          </span>
        </b-col>
      </b-row>
      <b-row>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey">Dirección</label>

          <span>
            {{ detailOS.direction }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey">Referencia</label>
          <span>
            {{ detailOS.reference }}
          </span>
        </b-col>
      </b-row>
    </div>
    <div class="padding-five-all bg-white no-printme" >
      <h5 class="text-orange">Datos de la Visita Técnica</h5>
      <b-row>
        <b-col cols="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey">Nota de venta</label>

          <span>
            {{ detailOS.sellerNote }}
          </span>
        </b-col>
        <b-col cols="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey">SKU servicio</label>

          <span>
            {{ detailOS.serviceSku }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey"
            >Descripción SKU servicio</label
          >
          <span>
            {{ detailOS.serviceDescription }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey">SKU producto</label>

          <span>
            {{ detailOS.referenceSku }}
          </span>
        </b-col>
      </b-row>
      <b-row>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey"
            >Descripción SKU producto</label
          >
          <span>
            {{ detailOS.referenceDescription }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey">Cantidad</label>
          <span>
            {{ detailOS.quantity }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey"
            >Fecha estimada del servicio</label
          >
          <span>
            {{ detailOS.estimatedDate }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey">Turno</label>
          <span>
            {{ detailOS.turn }}
          </span>
        </b-col>
      </b-row>
      <b-row>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey">Nombre</label>
          <span>
            {{ detailOS.provider }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey">Técnico</label>
          <span>
            {{ detailOS.technician }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey"
            >Observaciones del cliente</label
          >
          <span>
            {{ detailOS.clientObservation }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey"
            >Observaciones al proveedor</label
          >
          <span>
            {{ detailOS.providerObservation }}
          </span>
        </b-col>
      </b-row>
      <b-row>
        <b-col  xs="5" sm="5" md="5" lg="5">
         
        <b-button
         v-b-modal.modal-informe @click="setIdInform()" variant="success">
          Informe técnico
          </b-button>
        </b-col>
      </b-row>
      
    </div>
    <div class="padding-five-all bg-white no-printme ">
      <h5 class="text-orange">Datos Gestión</h5>
      <b-row>
        <b-col lg="12">
          <b-row>
            <b-col lg="2">
              <label for="input-small" class="text-grey">
                N° Cotización
              </label>
               <b-form-input v-model="project.cotizacion" ></b-form-input>
              
            </b-col>
             
             <b-col lg="2">
              <label for="input-small" class="text-grey">
                Estado de Gestión <span style="color:red">(*) </span>
              </label>
              <b-form-group>
              <b-form-select
               @change="getSubstatesProject"
                v-model="selectedState"
                size="md"
                :options="projectStates"
              ></b-form-select>
            </b-form-group>
            </b-col>
             <b-col lg="2">
              <label for="input-small" class="text-grey">
                SubEstado de Gestión<span style="color:red">(*) </span>
              </label>
              
               <b-form-group>
                
              <b-form-select
                @change="resetValuesProject"
                v-model="selectedSubstate"
                size="md"
                :options="projectSubStates"
              ></b-form-select>
            </b-form-group>
            </b-col>
            <b-col lg="4" v-show="showObservaciones">
              <label for="input-small" class="text-grey">
                Observaciones
              </label>
                <b-form-textarea
                  id="textarea"
                  v-model="observacionesProyecto"
                  placeholder=""
                  rows="3"
                  max-rows="6">
                  </b-form-textarea>
            </b-col>
            <b-col lg="2" v-if="showMotivosPerdido">
               <label for="input-small" class="text-grey">
                Motivos 
              </label>
              
               <b-form-group>
                
              <b-form-select
                v-model="project.idMotivo"
                size="md"
                :options="projectMotivosPerdido"
              >
                <b-form-select-option :value="0">
                  Seleccione una opción
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
            </b-col>
            <b-col lg="2" v-else-if="showMotivosAnulado" >
               <label for="input-small" class="text-grey">
                Motivos 
              </label>
              
               <b-form-group>
                
              <b-form-select
                v-model="project.idMotivo"
                size="md"
                :options="projectMotivosAnulado">
                  <b-form-select-option :value="0">
                    Seleccione una opción
                  </b-form-select-option>
              </b-form-select>
            </b-form-group>
              
            </b-col>
            <!-- <b-col lg="2">
              <label for="input-small" class="text-grey">
                Enviado a Cliente
              </label>
             <b-form-checkbox
              id="checkbox-1"
              v-model="statusClient"
              name="checkbox-1"
              value="accepted"
              unchecked-value="not_accepted"
            >
             
            </b-form-checkbox>
            </b-col> -->
          </b-row>
        </b-col>
      </b-row>
      <b-row v-show="selectedState=='2'&&(this.selectedSubstate=='3'||this.selectedSubstate=='4')">
        <b-col xs="12" lg="12">
              <label for="input-small" class="text-grey">
                Cotizaciones DAD
              </label>
               <b-row>
              <b-col xs="12" md="3" lg="3">
                <div class="border-dashed">
                  <div
                    class="dropzone-container"
                    @dragover="dragover"
                    @dragleave="dragleave"
                    @drop="drop"
                  >
                    <input
                      type="file"
                      multiple
                      name="file"
                      id="fileInput"
                      class="hidden-input"
                      @change="onChange"
                      ref="file"
                      accept=".pdf"
                    />

                    <label for="fileInput" class="file-label">
                      <div v-if="isDragging">
                        Suelte para soltar archivos aquí.
                      </div>
                      <div v-else class="vertical-align-middle">
                        <b-row>
                          <b-col
                            md="3"
                            class="border-all-green padding-none-lr center-div"
                          >
                            <font-awesome-icon
                              style="color: #19be2b"
                              icon="arrow-up"
                              class="text-center"
                            />
                          </b-col>
                        </b-row>
                        <b-row>
                          <div
                            class="text-center"
                            style="font-size: 13px; color: #405568"
                          >
                            Arrastra los archivos o Haz click aquí para que se carguen
                          </div>
                        </b-row>
                      </div>
                    </label>
                  </div>
                </div>
              </b-col>
              <b-col xs="12" md="3" lg="3" >
                <p class="text-bold">Subir PDF (max. 3 archivos)</p>
               <!-- <b-row>
                  <b-button :disabled="enableUpload" @click="uploadImage">Cargar PDF</b-button>
                </b-row> -->
                
                <!--<span>Debes subir un mínimo de 3 archivos</span> -->
                <div v-if="files.length">
                  <b-list-group>
                    <b-list-group-item
                      class="d-flex justify-content-between align-items-center"
                      style="font-size: 13px"
                      v-for="file in files"
                      :key="file.name"

                    >
                      {{ file.name }}
                      {{ Math.round(file.size / 1000) + "kb" }}
                      <b-badge @click="remove(files.indexOf(file))">x</b-badge>
                    </b-list-group-item>
                  </b-list-group>
                </div>

                
              </b-col>
              <b-col xs="12" md="4" lg="4">
                <template v-if="project.cotizaciones.length">
                  <div>
                    <p class="text-bold">Archivos</p>
                    <b-list-group>
                    <b-list-group-item
                      class="d-flex justify-content-between align-items-center"
                      style="font-size: 13px"
                      v-for="cotizacion in project.cotizaciones"
                      :key="cotizacion.id"
                      
                    >
                    <a class="word-break text-short" :href="cotizacion.url">
                     <span v-if="cotizacion.filename">
                      {{cotizacion.filename}}
                     </span>
                      <span v-else>
                        {{cotizacion.url}}
                      </span>
                      
                      </a>
                      
                    </b-list-group-item>
                  </b-list-group>
                  </div>
                </template>
              </b-col>
            </b-row>
            </b-col>
      </b-row>
     <!-- <b-row class="padding-top-five">
        <b-col lg="6">
          <b-button class="bg-orange-btn" v-b-modal.modal-asociar :disabled="enableAsociarOs">
                Asociar OS
          </b-button>
        </b-col>
      </b-row> -->
      <b-row>
        <b-col lg="12" class="text-center">
          <b-row>
            <b-col cols="6" class="text-right">
              <b-button class="bg-orange-btn " :disabled="enableGuardar" @click="updateProject">
                Guardar
              </b-button>
            </b-col>
            <b-col cols="6" class="text-left">
              <b-button class="bg-orange-btn " v-b-modal.modal-asociar :disabled="enableAsociarOs">
                Asociar OS
          </b-button>
            </b-col>
          </b-row>
        
        </b-col>
      </b-row>
    </div>
      <section class="bg-white padding-five-all">
        <b-row>
            <h5 class="text-orange">Historial</h5>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-table :items="trackingOS" :fields="fieldsTracking">
              <template #cell(datehour)="data">
                {{ data.item.date }} {{ data.item.hour }}
              </template>
              
            
            
              <template #cell(observations)="data">
                <span v-if="!data.item.observations"> - </span>
                <span v-else> {{ data.item.observations }}</span>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </section>
    <div class="no-printme">
      <b-modal
        header-text-variant="modal-asociar"
        id="modal-asociar"
        centered
        hide-footer
        size="xl"
        title="Creación Os"
      >
        <modal-edit :idTechInform="idTechInform" :idProject="project.id"> </modal-edit>
      </b-modal>
    </div>
    <div >
       <b-modal
        header-text-variant="modal-informe"
        id="modal-informe"
        centered
        hide-footer
        size="lg"
        title="Informe Técnico">
        
        <informe-tecnico :idTechInform="idTechInform">
          <template slot="button-print">
            <b-button @click="printInform" class="btn-orange">
              <font-awesome-icon icon="print" /> IMPRIMIR
            </b-button>
          </template>
        </informe-tecnico>
       </b-modal>
    </div>
    <section id="printSection" v-if="isPrinting">
      <impresion-informe :idTechInform="idTechInform"> </impresion-informe>
    </section>
  </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";
import InformeTecnico from "../../components/VisitaTecnica/InformeTecnico.vue";
import ModalEdit from "../../components/Proyectos/ModalEdit.vue"

import moment from "moment";
import ImpresionInforme from './ImpresionInforme.vue';
export default {
  name: "DetalleProyecto",
  data() {
    return {
      fieldsTracking: [
        {
          key: "fecha_registro",
          label: "Fecha registro",
        },
        {
          key: "usuario_modificacion",
          label: "Usuario",
        },
        {
          key: "estado",
          label: "Estado",
        },
        {
          key: "subestado",
          label: "Sub Estado",
        },
        {
          key: "motivo_desc",
          label: "Motivo",
        },
        {
          key: "observaciones",
          label: "Observaciones",
        },
      ],
      trackingOS:{},
      isPrinting:false,
      selectedSubstate:null,
      selectedState:null,
      observacionesProyecto:"",
      file2:null,
      statusClient:"accepted",
      projectMotivosPerdido:[
        { value: 1, text: "Cliente ya contrato por su cuenta" },
        { value: 2, text: "Cliente no responde" },
        { value: 3, text: "Precio elevado" },
        { value: 4, text: "Desacuerdo con precio/disponibilidad de productos" },
        { value: 5, text: "Cliente posterga el proyecto" },
        { value: 6, text: "No se cuenta con el servicio requerido" },
        { value: 7, text: "Ambiente no apto" }
      ],
      projectMotivosAnulado:[
        { value: 10, text: "Prueba" },
        {value:11,text:"Visita Tec. anulada"}
      ],
      projectSubStates: [
        
        { value: null, text: "Elige una opción" }
      ],
      projectStates: [
        
        { value: null, text: "Elige una opción" }
      ],
      project:{
        estado:0,
        subEstado:0,
        observaciones:"",
        cotizacion:null,
        cotizaciones:[],
        idMotivo:null,
        FechaRegistro:null,
        id_os_instalacion:null

      },
      idTechInform:"",
      detailOS: {},
      items: [
        {
          text: "Proyectos",
          to: { name: "Proyectos" },
        },
        {
          text: "Detalle OS",
        },
      ],
      files:[],
      isDragging: false,
      filesCotizaciones:[]
    };
  },
  components:{
    InformeTecnico,
    ModalEdit,
    ImpresionInforme
  },
  computed:{
    ...mapState("module", [
      "token","username"
    ]),
    showObservaciones(){
      if(this.selectedState==2||(this.selectedState==3&&this.selectedSubstate==5)||(this.selectedState==3&&this.selectedSubstate==2)
      ||(this.selectedState==3&&this.selectedSubstate==6)) return true
      return false;
    },
    showMotivosPerdido(){
      if(this.selectedState==3 &&this.selectedSubstate==6) return true
      return false
    },
    showMotivosAnulado(){
      if(this.selectedState==3 &&this.selectedSubstate==2) return true
      return false
    },
    enableUpload(){
      if(!this.files.length)return true
      return false
    },
    enableAsociarOs(){
      if(this.project.estado==3 &&this.project.subEstado==5&&this.project.id_os_instalacion==null)return false
      return true
    },
    enableGuardar(){
      if(this.selectedState&&this.selectedSubstate){
        
       /* if(this.selectedState==2&&this.selectedSubstate==3 &&this.files.length==0)
        return true
         
        }
        else if(this.project.estado==3 &&this.project.subEstado==5)return true */
         if(this.selectedState==3 &&this.selectedSubstate==6 && !this.project.idMotivo){
          return true
        }
        return false
      }
      
      return true
    },
    formattedDate(){
      if(this.project.FechaRegistro) return moment(this.project.FechaRegistro).format("DD/MM/YYYY")
      else return ""
    }
  },
  created() {
    this.getProject();
    this.tracking();
    
  },
  methods: {
    async tracking() {
      try {
        const fetchedId = this.$route.params.id;
        if (this.$route.params.id !== fetchedId) return;
        this.$store.commit("SET_LOADING", true);
        let response = await axios.get(
          process.env.VUE_APP_PROJECT_BASE +
            "/tracking?idProject=" +
            this.$route.params.id,
            {
              headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer "+ this.token
              },
            }
        );
        console.log(response);

        this.trackingOS = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.commit("SET_LOADING", false);
      }
    },
    printInform(){
      this.isPrinting=true;
      window.print();
    },
    resetValuesProject(){
      this.project.idMotivo=0;
      this.observacionesProyecto="";
    },
    formatDate(val) {
      
      return moment(val, "DD/MM/YY").format("DD/MM/YYYY");
    },
    async  getStatesAndSubStates(){
      try{
        this.$store.commit("SET_LOADING", true);
        await Promise.all([this.getSubstatesProjectV2(), this.getStatesProject(),this.getDetails()]);
      }
      catch(e){
        console.log(e)
      }
      finally{
        this.$store.commit("SET_LOADING", false);
      }
      

    },
    remove(i) {
      this.files.splice(i, 1);
    },
     dragover(e) {
      e.preventDefault();
      this.isDragging = true;
    },
    dragleave() {
      this.isDragging = false;
    },
    drop(e) {
      e.preventDefault();
      this.$refs.file.files = e.dataTransfer.files;
      this.onChange();
      this.isDragging = false;
    },
    onChange() {
      let filesArr = this.$refs.file.files;
      let file = filesArr[0];
      this.files.push(file);
      //this.files = [...this.$refs.file.files];
    },
    async getFile(file) {
      //const file = this.files[0];
      let time = this.getTimestamp();
      const reader = new FileReader();
      return new Promise((resolve) => {
        reader.onload = (ev) => {
          let data = {
            src: ev.target.result,
            filename: time + file.name,
          };
          resolve(data);
        };
        reader.readAsDataURL(file);
      });
    },
    getTimestamp() {
      return new Date().getTime();
    },
    async uploadPdfProject() {
      try {
        let response = await axios.post(
          process.env.VUE_APP_PROJECT_BASE + "/quotation",
          this.filesCotizaciones,
          {
            headers: {
              "Content-type": "application/json",
            },
          }
        );
        console.log(response);
      } catch (e) {
        console.log(e);
        this.sendAlert("danger", e.message);
      }
    },
    async uploadImage() {
    //  this.$store.commit("SET_LOADING", true);
    if(!this.files.length) return;
      const listSrc = [];
      for (var i = 0; i < this.files.length; i++) {
        let res = await this.getFile(this.files[i]);
        console.log(res);
        listSrc.push({
          src: res.src,
          filename: res.filename,
        });
      }
      try {
        for (var x = 0; x < listSrc.length; x++) {
          let response = await axios.post(
            process.env.VUE_APP_BASE_ONETRACK_EXT + "/upload-photo",
            {
              user: this.username,
              image: listSrc[x].src,
              type: "project",
              filename: listSrc[x].filename,
            }, // the data to post
            {
              headers: {
                "Content-type": "application/json",
              },
            }
          );
          this.filesCotizaciones.push({
            idProject: this.project.id,
            url: response.data.imageUrl,
            username: this.username,
            filename:listSrc[x].filename
          });
        }
        
      } catch (error) {
        this.sendAlert("danger", error.response.data.message);
      } finally {
        setTimeout(() => {
          this.$store.commit("setShowAlert", false);
        }, 3000);
      }
     await this.uploadPdfProject();
    },
    async getSubstatesProject() {
      try {
        if(this.selectedSubstate) this.selectedSubstate=null;
        this.$store.commit("SET_LOADING", true);
        let response = await axios.get(
          process.env.VUE_APP_PROJECT_BASE +
            "/substates?estado=" +
            this.selectedState
        );
        const data = response.data.map((row) => {
          return {
            value: row.id,
            text: row.descSubEstado,
          };
        });
        this.projectSubStates = data;
        
      } catch (error) {
        console.log(error);
      }
      finally{
        this.$store.commit("SET_LOADING", false);
      }
    },
    async getSubstatesProjectV2() {
      try {
        
        let response = await axios.get(
          process.env.VUE_APP_PROJECT_BASE +
            "/substates?estado=" +
            this.project.estado
        );
        const data = response.data.map((row) => {
          return {
            value: row.id,
            text: row.descSubEstado,
          };
        });
        this.projectSubStates = data;
        
      } catch (error) {
        console.log(error);
      }
      finally{
        //this.$store.commit("SET_LOADING", false);
      }
    },
    async getStatesProject() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_PROJECT_BASE + "/states"
        );
        const data = response.data.map((row) => {
          return {
            value: row.id,
            text: row.descEstado,
          };
        });
        this.projectStates = data;
      } catch (e) {
        console.log(e);
      }
    },
    
    async updateProject() {
      try {
        this.$store.commit("SET_LOADING", true);
        await this.uploadImage();
        let response = await axios.put(
          process.env.VUE_APP_PROJECT_BASE + "/" + this.project.id,
          {
            id: this.project.id,
            estado: this.selectedState,
            osOrigen: "",
            subEstado: this.selectedSubstate,
            observaciones:this.observacionesProyecto,
            Desc_Estado:"",
            DocIdentidad:"",
            FechaRegistro:null,
            Desc_SubEstado:"",
            cotizacion:this.project.cotizacion,
            cotizaciones:[],
            idMotivo:this.project.idMotivo,
            Usuario:this.username
          }, // the data to post
          {
            headers: {
              "Content-type": "application/json",
            },
          }
        );
        console.log(response);
        let values = { variant: "success", msg: "Se actualizó exitosamente !" };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
        await this.getProject();
        
        
        this.clearValues()
      } catch (error) {
        console.log(error);
        let values = { variant: "danger", msg: error.response.data.message };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
      } finally {
        this.$store.commit("SET_LOADING", false);
        setTimeout(() => this.$store.commit("setShowAlert", false), 3000);
       
      }
    },
    clearValues(){
      this.observacionesProyecto="";
    },
    async getProject() {
      this.$store.commit("SET_LOADING", true);
      try {
        const fetchedId = this.$route.params.id;
        if (this.$route.params.id !== fetchedId) return;
        let response = await axios.get(
          process.env.VUE_APP_PROJECT_BASE +
            "/" +
            this.$route.params.id,
            {
              headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer "+ this.token
              },
            }
        );
        console.log(response);

        this.project = response.data;
        this.selectedState=response.data.estado;
        this.selectedSubstate=response.data.subEstado;
        await this.getStatesAndSubStates();
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.commit("SET_LOADING", false);
      }
    },
    setIdInform() {
      const reportId = this.$route.params.informe;
      this.idTechInform = parseInt(reportId);
      this.isPrinting=true;
    },
    async getDetails() {
     // this.$store.commit("SET_LOADING", true);
      try {
        const fetchedId = this.$route.params.os;
        if (this.$route.params.os !== fetchedId) return;
        let response = await axios.get(
          process.env.VUE_APP_RECORDS_BUSINESS_BASE +
            "/summaries/children/" +
            this.$route.params.os,
            {
              headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer "+ this.token
              },
            }
        );
        console.log(response);

        this.detailOS = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
@media screen {
  #printSection {
      display: none;
  }
}
@media print {
  ::v-deep .b-table thead {
  color: black !important;
  font-weight: 500 !important;
}
::v-deep .b-table thead th {
  font-weight: 500 !important;
}
  body * {
    visibility:hidden;
  }
  #printSection, #printSection * {
    visibility:visible;
  }
  #printSection {
    position:absolute;
    left:0;
    top:0;
  }
}
.text-short{
  white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
.text-left{
  text-align: left;
}
.text-right{
  text-align: right;
}
.word-break{
  word-break:break-all
}
.padding-top-five{

  padding-top: 2%;
}
.hidden-icon {
  visibility: hidden;
}
.form-control {
  border: none;
  border-bottom: 1px solid #ced4da;
  padding: 5px 10px;
  outline: none;
  border-radius: 0;
}
@media (max-width: 600px) {
  .xs-hidden {
    display: none;
  }
  .show-icon {
    visibility: visible;
    padding-right: 4px;
  }
}
.color-gray {
  color: #676767;
  font-weight: bold;
}
.padding-ten-lr {
  padding: 10px;
  padding-left: 30px !important;
}

::v-deep.breadcrumb {
  background: transparent !important;
  justify-content: flex-end;
  color: #676767;
  font-weight: bold;
}
a:hover {
  color: rgb(254, 123, 1) !important;
}
a {
  color: #676767 !important;
}
.bg-grey-btn {
  background: #676767;
  color: white;
}

.margin-five-rigth {
  margin-right: 50%;
}

.text-orange {
  color: #ff7a00;
}

::v-deep .b-table thead {
  background: rgb(254, 123, 1);
  color: white;
  font-weight: 400 !important;
}
::v-deep .b-table thead th {
  font-weight: 400 !important;
}
.text-bold{
  font-weight: 700;
}

@media (max-width: 575.98px) {
  .margin-five-rigth {
    margin: 0;
  }
  .padding-five-bottom {
    padding-bottom: 5px;
  }
  .text-grey {
    color: #676767;
    font-size: 15px;
    letter-spacing: 0px;
    display: block;
    margin-bottom: 0.5rem;
  }
  .dropzone-container {
  padding: 2.5rem;
  background: #fafafa;
  border: 1px dashed #c0c0c0;
}
}
</style>
